/**
 * Registry of the six worlds' client art (themes + scenic maps). Pre-populated: world authors only
 * edit their own `art/worlds/<id>/` folder.
 */
import type { PathId } from '@sketchling/core';
import type { WorldArt } from './types';
import { INTRO_ART } from './intro';
import { ANIMALS_ART } from './animals';
import { NATURE_ART } from './nature';
import { CHARACTERS_ART } from './characters';
import { ANIME_ART } from './anime';
import { CUTE_ART } from './cuteObjects';

export * from './types';

export const WORLD_ART: Record<PathId, WorldArt> = {
  intro: INTRO_ART,
  animals: ANIMALS_ART,
  nature: NATURE_ART,
  characters: CHARACTERS_ART,
  anime: ANIME_ART,
  cuteObjects: CUTE_ART,
};

/** World of a drawing (by subject category) — used for card backgrounds outside the path map. */
export const CATEGORY_WORLD: Record<string, PathId> = {
  animals: 'animals',
  nature: 'nature',
  characters: 'characters',
  anime: 'anime',
  fantasy: 'anime',
  cuteObjects: 'cuteObjects',
  food: 'cuteObjects',
  shapes: 'intro',
  vehicles: 'characters',
};

import { type Drawing } from '@sketchling/core';
import { DRAWING_WORLD } from '../../lib/content';

/** World a drawing belongs to (its owning world, else by subject category). */
export const worldOf = (d: Pick<Drawing, 'id' | 'category'>): PathId => DRAWING_WORLD[d.id] ?? (CATEGORY_WORLD[d.category] as PathId | undefined) ?? 'intro';
